<template>
  <f-dashboard-content-wrapper>
    <f-list
      :store="storeId"
      :query="query"
    >
      <template #list-actions="{ state }">
        <div class="is-grid is-aligned m-vertical-12">
          <div class="is-col-8 is-aligned">
            <f-input 
              v-model="state.search"
              placeholder="Recherche" 
            ></f-input>
          </div>

          <div class="is-col-4 is-aligned-right">
            <f-button-link 
              v-if="canCreate"
              :to="{ name: 'home' }"
              size="small"
              fill
            >
              <i class="uil uil-plus"></i> Créer 
            </f-button-link>
          </div>
        </div>
      </template>

      <template #list-header="{ state, selectAll }">
        <subscription-header>
          <template #select-all>
            <div class="is-centered m-horizontal-12">
              <f-checkbox 
                :model-value="state.allSelected"
                @change="selectAll"
              ></f-checkbox>
            </div>  
          </template>
        </subscription-header>
      </template>

      <template #list-item="{ item, state, toggleSelection }">
        <subscription-item
          :subscription="item"
          :is-selected="state.selected.has(item._id)"
          @toggle-selection="toggleSelection"
        ></subscription-item>
      </template>
    </f-list>
  </f-dashboard-content-wrapper>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import { useDate, formatDate } from '@composables/use-date'
  import useConstantsWording from '@composables/use-constants'
  import router from '@core/router'
  import useRoles from '@composables/use-roles'
  import SubscriptionItem from './item/subscription-item'
  import SubscriptionHeader from './header/subscription-header'
  
  export default {
    setup () {
      const userId = computed(() => router.currentRoute.value.params.id)
      const storeId = ref('@freebe/subscriptions')
      const query = { user_id: userId.value }
      const { checkPermissions } = useRoles()

      if (!checkPermissions('freebe/subscriptions:find')) {
        router.replace({ 
          name: 'user-profile',
          params: {
            id: userId.value
          } 
        })
      }

      const canCreate = computed(() => 
        checkPermissions('freebe/subscriptions:create')
      )


      return {
        canCreate,
        storeId,
        query,
      }
    },

    components: {
      SubscriptionItem,
      SubscriptionHeader,
    },
  }
</script>